// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__VIKg5","right":"styles_right__1wnQ_"};